import { StyleProp, ViewStyle } from "react-native";
import { ShareShareDataType, useShareShare } from "src/components/ShareMenu";
import IconShare from "src/icons/IconShare";
import FloatingActionItem from "./FloatingActionItem";

const FloatingShareButton = ({
	data,
	containerStyle,
}: {
	data: ShareShareDataType;
	containerStyle?: StyleProp<ViewStyle>;
}) => {
	const { handlePress, loading } = useShareShare();

	return (
		<FloatingActionItem
			loading={loading}
			Icon={IconShare}
			onPress={async () => {
				await handlePress(data);
			}}
			containerStyle={containerStyle}
			testID="Select-Share"
		/>
	);
};
export default FloatingShareButton;
